export const menu = [

    { name: 'Home', class: 'home', url: '/?section=home', target: 'home-section-1'},
    { name: 'Quem somos', class: 'about', url: '/?section=about', target: 'home-section-2'},
    { name: 'Soluções', class: 'solutions', url: '/?section=solutions', target: 'home-section-4'},
    { name: 'Redes Sociais', class: 'social', url: '/?section=social', target: 'home-section-5'},
    { name: 'Contato', external: true, class: 'contact', url: 'https://lp.vlgivida.com.br/fale-especialista'},
    { name: 'Fale com um Especialista', external: true, class: 'talk-with', url: 'https://lp.vlgivida.com.br/fale-especialista' }
]
